// extracted by mini-css-extract-plugin
export var bg = "Titles-module--bg--vFE1T";
export var head = "Titles-module--head--BG8VX";
export var headline = "Titles-module--headline--TmXr5";
export var item = "Titles-module--item--uY+Up";
export var itemLast = "Titles-module--item-last--72opX";
export var items = "Titles-module--items--Bi3Bx";
export var list = "Titles-module--list--OnwnD";
export var subheadline = "Titles-module--subheadline--lmc6p";
export var wrapper = "Titles-module--wrapper--1Th+0";